// src/components/FeatureCard.jsx

import React from "react";
import "./FeatureCard.css";
import icons from "../assets/icons";

const FeatureCard = ({ iconName, title, description }) => {
  // Pega o ícone do nosso objeto centralizador.
  // Pode ser um Componente React (para SVGs) ou uma string de URL (para PNGs).
  const Icon = typeof iconName === "string" ? icons[iconName] : iconName;

  return (
    <div className="feature-card">
      <div className="feature-icon-wrapper">
        {Icon &&
          (typeof Icon === "string" ? (
            // Se for uma string, é uma URL de imagem (PNG, JPG, etc.)
            <img src={Icon} alt={title} className="feature-icon" />
          ) : (
            // Senão, é um Componente React (nosso SVG)
            // <FramedIcon IconComponent={Icon} />
            <Icon className="feature-icon" />
          ))}
      </div>
      <div className="feature-text-wrapper">
                <h3>{title}</h3>        {description && <p>{description}</p>}   
      </div>
    </div>
  );
};

export default FeatureCard;
